import React from "react";

class ReportForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            words: []
        }

        this.open = this.open.bind(this);
    }

    componentDidMount() {
        this.props.openReport(this.open);

        var modal = document.getElementsByClassName("report-container")[0];
        window.onclick = event => {
            if (event.target === modal) {
                this.close();
            }
        }
    }

    submitReport() {
        var words = Array.from(document.getElementsByClassName("checkbox")).filter(b => b.checked).map(b => b.value);
        this.close();
        if (words.length > 0) {
            fetch("https://george-plays-wordle-backend.herokuapp.com/submit_issue", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ "words": words }),
            })
            .then(() => {})
            .catch(() => {});
        }
    }

    open() {
        this.setState({words: this.props.getWords()});
        var reportContainer = document.getElementsByClassName("report-container")[0];
        reportContainer.style.display = "flex";
        reportContainer.setAttribute("data-animation", "in");
        document.getElementsByClassName("report-modal")[0].setAttribute("data-animation", "in");
    }

    close() {
        var reportContainer = document.getElementsByClassName("report-container")[0];
        reportContainer.setAttribute("data-animation", "out");
        document.getElementsByClassName("report-modal")[0].setAttribute("data-animation", "out");
        setTimeout(() => {
            reportContainer.style.display = "none";
            reportContainer.removeAttribute("data-animation");
            document.getElementById("issue-form").reset();
        }, 400);
    }

    render() {
        return (
            <div className="report-container">
                <div className="report-modal">
                    <span className="close" onClick={this.close}>&times;</span>
                    <div className="report-content">
                        <div className="report-title">
                            Report non-words
                        </div>
                        <form id="issue-form">
                            {this.state.words.map((word, index) => 
                                <div key={index} className="checkbox-container">
                                    <input type="checkbox" className="checkbox" id={"word" + index} name={"word" + index} value={word} />
                                    <label htmlFor={"word" + index}>{word}</label>
                                </div>
                            )}
                            <input className="report-submit" type="button" value="Confirm" onClick={this.submitReport.bind(this)}/>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReportForm;